import { router, usePage } from "@inertiajs/react"
import { useEffect, useRef, useState } from "react"
import { toast } from "sonner"

import type { Flash } from "@/types"

const emptyFlash: Flash = {}

export const useFlash = () => {
  const { flash } = usePage<{ flash: Flash }>().props
  const [currentFlash, setCurrentFlash] = useState<Flash>(flash || emptyFlash)
  const hasRegisteredListener = useRef(false)

  // Update currentFlash when flash prop changes
  useEffect(() => {
    if (flash) {
      setCurrentFlash(flash)
    }
  }, [flash])

  // Register router event listener only once
  useEffect(() => {
    if (!hasRegisteredListener.current) {
      hasRegisteredListener.current = true

      const removeStartListener = router.on("start", () => {
        setCurrentFlash(emptyFlash)
      })

      // Cleanup function to remove listener
      return () => {
        removeStartListener()
      }
    }
  }, [])

  // Show toast notifications
  useEffect(() => {
    if (!currentFlash) return

    if (currentFlash.alert) {
      toast.error(currentFlash.alert)
    }
    if (currentFlash.notice) {
      toast(currentFlash.notice)
    }
  }, [currentFlash])
}
